import React, { MouseEventHandler } from 'react';
import { ServiceType, StatusType } from './types';

export const statusColorMap: Record<
  StatusType,
  'success' | 'warning' | 'default' | 'secondary' | undefined
> = {
  Popular: 'success',
  New: 'warning',
  'Soon!': 'default',
  Advance: 'secondary',
  '': undefined,
};

export const modalTitleMap: Record<string, string> = {
  'Company Lookalike Search': 'Similarity Company Search',
  'People Lookalike Search': 'Similarity People Search',
  'AI Semantic Company Search': 'AI Semantic Search',
  'AI Analysis by LinkedIn Profile': 'AI Analysis',
};

export const getModalTitle = (title: string): string =>
  modalTitleMap[title] || 'Search';

export const handleButtonClickConfig = (
  onStart: MouseEventHandler<HTMLButtonElement> | undefined,
  title: string,
  handleOpenModal: (
    type: ServiceType,
    event: React.MouseEvent<HTMLElement>
  ) => void
): MouseEventHandler<HTMLButtonElement> => {
  return (event) => {
    if (onStart) {
      onStart(event);
      switch (title) {
        case 'Company Lookalike Search':
          handleOpenModal(ServiceType.Similarity, event);
          break;
        case 'People Lookalike Search':
          handleOpenModal(ServiceType.People, event);
          break;
        case 'AI Semantic Company Search':
          handleOpenModal(ServiceType.Semantic, event);
          break;
        case 'AI- Contact Profile Analytics':
          handleOpenModal(ServiceType.Analysis, event);
          break;
        default:
          break;
      }
    }
  };
};
